export class BaseIconComponent {}
